<template>
	<footer class="footer">
		<div class="footer__nav">
			<div class="container">
				<nav class="nav">
					<!-- <a class="nav-link" href="https://ostock.id/terms-of-use/" target="_blank">Terms of Use</a> -->
					<!-- <a class="nav-link" href="https://ostock.id/disclaimer/" target="_blank">Disclaimer</a> -->
					<a class="nav-link" href="https://help.ostock.id" target="_blank">Help Center</a>
					<a class="nav-link" href="https://ostock.id/page/privacy" target="_blank">Privacy Policy</a>
					<!-- <a class="nav-link" href="https://ostock.id/antispam/" target="_blank">Antispam</a> -->
					<!-- <router-link class="nav-link" to="/changelog">Changelog</router-link> -->
				</nav>
			</div>
		</div>
		<div class="footer__bottom">
			<div class="container">
				<div class="text-center">
					<div class="footer-copyright">Copyright &copy; {{ year }} Ostock.id</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	name: 'siteFooter',
	computed: {
		year() {
			return new Date().getFullYear();
		},
	},
};
</script>
